module.exports = __webpack_public_path__ + "img/la-tomatina-2012-1.e4ad4aa9.jpg";